
export default (to, from, next) => {
  if (localStorage.getItem('role') === 'company_user') {
    next()
  } else {
    next('/global/PageNotFound')
  }
}
